import api from "../_api";

const actions = {
    updateClasses: ({ commit }, payload) => {
        commit("UPDATE_CLASSES", payload);
    },
    classErrors: ({ commit }, payload) => {
        commit("CLASS_ERROR", payload);
    },
    clearClassErrors: ({ commit }) => {
        commit("CLEAR_CLASS_ERROR");
    },
    classesRequest: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            commit("CLASS_LOADING");

            api.classes(payload.week)
                .then(resp => {
                    commit("CLASS_SUCCESS", resp.data.data);
                    resolve(resp.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                    }

                    commit("CLASS_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
    bookRequest: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit("CLASS_LOADING");

            let data = {
                classData: payload.class_id,
                classAction: payload.class_action,
                classWeek: payload.week,
            };

            api.bookclass(data)
                .then(resp => {
                    commit("CLASS_SUCCESS", resp.data.data);
                    dispatch('classes/classesRequest', {week: payload.week}, { root: true });

                    resolve(resp.data);
                })
                .catch(err => {
                    let errors = { error: "Techinal Issue, Please try again later" };
                    let errorMsg = errors.error;
                    if (err.response.status != 500) {
                        errors = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                        errorMsg = err.response.data.errors ? err.response.data.errors.error : err.response.data.error;
                    }

                    commit("CLASS_ERROR", errors);
                    reject(errorMsg);
                });
        });
    },
};

export default actions;
